import constants from './actions/constants'

const INITIAL_STATE = {
  username: null,
  authHash: null,
  vendorIdd: null,
  vendorName: null,
  permissions: [],
  fetching: false,
  users: [],
  crews: [],
  vendors: [],
  allPermissions: [],
  isAuthenticated: false,
  baseUser: null,
  isImpersonating: false
}

const user = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case constants.LOGIN_FETCH:
      return state

    case constants.LOGIN_SUCCESS:
      return { ...state, fetching: false, isAuthenticated: true, ...action.user }

    case constants.LOGIN_FAIL:
      return { ...INITIAL_STATE, fetching: false, isAuthenticated: false }

    case constants.LOGOUT_SUCCESS:
      return INITIAL_STATE

    case constants.USERS_FETCH:
      return { ...state, fetching: true }

    case constants.USERS_FETCH_SUCCESS:
      return { ...state, fetching: false, users: action.users }

    case constants.CREWS_FETCH:
      return { ...state, fetching: true }

    case constants.CREWS_FETCH_SUCCESS:
      return { ...state, fetching: false, crews: action.crews }

    case constants.VENDORS_FETCH:
      return { ...state, fetching: true }

    case constants.VENDORS_FETCH_SUCCESS:
      return { ...state, fetching: false, vendors: action.vendors }

    case constants.EMPLOYEES_FETCH:
      return { ...state, fetching: true }

    case constants.EMPLOYEES_FETCH_SUCCESS:
      return { ...state, fetching: false, employees: action.employees }

    case constants.PERMISSIONS_FETCH:
      return { ...state, fetching: true }

    case constants.PERMISSIONS_FETCH_SUCCESS:
      return { ...state, fetching: false, allPermissions: action.permissions }

    case constants.UPSERT_USER_SUCCESS:
      const { Username, VendorIdd, VendorName, Permissions, Confirmed } = action.user
      const usersCopy = state.users.slice()
      const foundIdx = usersCopy.findIndex(u => u.Username === Username)
      if (foundIdx === -1) {
        usersCopy.push(action.user)
      } else {
        usersCopy[foundIdx] = action.user
      }
      const user = Username === state.username ? { username: Username, vendorIdd: VendorIdd, vendorName: VendorName, permissions: Permissions, confirmed: Confirmed } : state.user

      return { ...state, ...user, users: usersCopy }

    case constants.BEGIN_IMPERSONATION:
      return {
        ...state,
        baseUser: {
          username: state.username,
          authHash: state.authHash,
          vendorIdd: state.vendorIdd,
          vendorName: state.vendorName,
          permissions: state.permissions,
          testHash: state.testHash
        },
        username: action.impersonatedUser.Username,
        authHash: action.impersonatedUser.AuthHash,
        vendorIdd: action.impersonatedUser.VendorIdd,
        vendorName: action.impersonatedUser.VendorName,
        permissions: action.impersonatedUser.Permissions,
        testHash: action.impersonatedUser.AuthHash,
        isImpersonating: true
      }

    case constants.END_IMPERSONATION:
      return { ...state, ...state.baseUser, isImpersonating: false, impersonatedUsername: null }

    case constants.SET_OVERRIDE_URL:
      return { ...state, overrideUrl: action.overrideUrl }

    default:
      return state
  }
}

export default user